import { MARGINS_BLOCKS } from '@features/cms/const';
import { TMarginsTypes } from '@features/cms/typescript';
import theme from '@styles/theme';
export default {
  headerContainer: (background: string, marginTop: TMarginsTypes, marginBottom: TMarginsTypes) => ({
    background,
    pt: MARGINS_BLOCKS[marginTop],
    pb: MARGINS_BLOCKS[marginBottom],
    position: 'relative',
    zIndex: theme.zIndex.documentUp
  }),
  headerWrapper: {
    p: ['64px 16px 0px', '64px 16px 0px', '80px 24px 0px', '80px 24px 0px', '116px 40px 0 40px']
  },
  imageContainer: {
    position: 'relative',
    width: ['100%', '100%', '100%', 'calc(100vw - 41.3020833vw)'],
    height: ['75vw', '75vw', '75vw', '100%'],
    img: {
      objectFit: 'cover',
      wordBreak: 'keep-all'
    }
  }
};